import React, { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";

const STORAGE_KEY = "portfolio_auth";

const AuthContext = createContext(null);

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [session, setSession] = useState(readStored);

  const token = session?.token || null;
  const fundName = session?.fund_name || null;
  const fundId = session?.fund_id || null;
  const role = session?.role || null;

  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }

  const login = useCallback((payload) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    setSession(payload);
    axios.defaults.headers.common["Authorization"] = `Bearer ${payload.token}`;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setSession(null);
    delete axios.defaults.headers.common["Authorization"];
  }, []);

  return (
    <AuthContext.Provider
      value={{ token, fundName, fundId, role, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
